import React from "react";
import Breadcrumbs, { type BreadcrumbItem } from "./Breadcrumbs";
import FlashMessage from "./FlashMessage";
import PageHero, { type PageHeroProps } from "./PageHero";

interface PageHeaderProps extends PageHeroProps {
  breadcrumbs?: BreadcrumbItem[];
  flash?: React.ComponentProps<typeof FlashMessage>["message"];
}

const PageHeader: React.FC<PageHeaderProps> = ({ breadcrumbs, flash, children, ...heroProps }) => {
  return (
    <header className="PageHeader">
      {breadcrumbs && breadcrumbs.length > 0 ? <Breadcrumbs items={breadcrumbs} /> : null}
      <FlashMessage message={flash} className="PageHeader-flash" />
      <PageHero {...heroProps}>{children}</PageHero>
    </header>
  );
};

export default PageHeader;
